import { render, staticRenderFns } from "./GlobalSwiper.vue?vue&type=template&id=0d855ffc&"
import script from "./GlobalSwiper.vue?vue&type=script&lang=ts&"
export * from "./GlobalSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSwiper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports